import { render, staticRenderFns } from "./nurserygrading.vue?vue&type=template&id=8bf30ae6&"
import script from "./nurserygrading.vue?vue&type=script&lang=js&"
export * from "./nurserygrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports